module.exports = __webpack_public_path__ + "static/media/thumb-sogal.0c131cb9.png";